import { Component, Input } from '@angular/core';
import { VizFooterComponent } from '@vizientinc/design-system-toolkit';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [VizFooterComponent],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

    @Input()
    footerTitle: string = 'Request a Login';
}
